export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10214.1f26ae45.jpg";